import Cookies from "js-cookie";

export type GetBestPriceInputs = {
  isBuyGetPage?: boolean;
  tag?: string;
  mpIds: number[];
  postalCode?: string;
  /** For use in managing the cache in a way taht doesn't affect the request, such as a factorId for an experiment. */
  additionalCacheKey?: string;
};
export type BestPricesMapResponse = {
  bestPriceMap: BestPriceProductInfoMap;
};
export type BestPriceProductInfoMap = {
  [key: number]: BestPriceProductInfo;
};

export type BestPriceProductInfo = {
  authorizerDistributorEnabled: boolean;
  averageShipTime: number;
  backOrdered: boolean;
  brandName: string;
  fulfillmentPolicyId: number;
  heavyShippingCost: number;
  inStockSw: boolean;
  inventory: number;
  manufacturerProductId: number;
  minQty: number;
  mpName: string;
  /** This is vendor name */
  name: string;
  url: string;
  lastPurchaseDate: string | null;
  priceEffectiveDate: string | null;
  priceEndingDate: string | null;
  productTag: null;
  quantity: number;
  retailPrice: number;
  shippingCost: number;
  subTotal: number;
  totalCost: number;
  unitPrice: number;
  vdrGeneralAverageRatingSum: number;
  vdrNumberOfGeneralRatings: number;
  vendorProductId: number;
};

/**
 * Avoid using this function directly if at all possible.  See the searchSlice makeGetBestPriceByMpIdSelector function
 * to use the reduc store instead.
 */
export const getBestPrices = async (request: GetBestPriceInputs) => {
  const { isBuyGetPage = false, tag = "", mpIds, postalCode } = request;
  const buyBoxFactorId = Cookies.get("buyBoxFactorIdExperiment");
  const applyAuthorizedBoosting = Cookies.get("applyAuthorizedBoostedExperiment");

  let url = `/rest/neo/search/getBestPrice`;
  if (buyBoxFactorId) {
    url += `?buyBoxFactorId=${encodeURIComponent(buyBoxFactorId)}`;
  }

  if (applyAuthorizedBoosting !== undefined && applyAuthorizedBoosting !== null) {
    url += buyBoxFactorId
      ? `&applyAuthorizedBoosting=${encodeURIComponent(applyAuthorizedBoosting)}`
      : `?applyAuthorizedBoosting=${encodeURIComponent(applyAuthorizedBoosting)}`;
  }

  const response = await fetch(url, {
    credentials: "include",
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      // "Content-Type": "application/x-www-form-urlencoded",
    },
    redirect: "follow", // manual, *follow, error
    body: JSON.stringify({ isBuyGetPage, tag, mpIds, postalCode }), // body data type must match "Content-Type" header
  });
  if (response.ok === true) {
    const responsePayload = (await response.json()) as BestPricesMapResponse;
    console.log(responsePayload);
    return responsePayload.bestPriceMap;
  }
};
